function injectMetaData(handler, scopeProvider) {
    return function (event, message, metadata = {}) {
        const scope = typeof scopeProvider === 'function' ? scopeProvider() : scopeProvider;
        handler.call(this, event, message, { ...scope, ...metadata });
    };
}
export const withScope = (scope, logger) => {
    const { debug, error, info, warn } = logger;
    return {
        ...logger,
        debug: injectMetaData(debug, scope),
        error: injectMetaData(error, scope),
        info: injectMetaData(info, scope),
        warn: injectMetaData(warn, scope),
    };
};
//# sourceMappingURL=with-scope.js.map